<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" size="mini">添加版本</el-button>
      </el-col>

      <el-col :span="5">
        <el-input placeholder="版本名称" v-model="params.version_name" style="width: 100%" size="mini">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table :data="versionList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>

      <el-table-column prop="version_name" label="版本名" width="150">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.version_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="version_num" label="版本号" width="100"></el-table-column>
      <el-table-column prop="downloads" label="下载地址" width="450"></el-table-column>
      <el-table-column prop="release_time" label="发布时间" width="160" align="center">
        <template slot-scope="scope">{{ scope.row.release_time|datetime('yyyy-MM-dd hh:mm:ss') }}</template>
      </el-table-column>
      <el-table-column prop="is_save" align="center" label="使用这个版本更新?" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_save" active-value="1" inactive-value="0" active-color="#13ce66"
                     inactive-color="#ff4949" @change="switchAuth(scope.$index, scope.row)"></el-switch>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="release_time" label="发布时间" width="180"></el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
      <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          :total="total_count" :page-size="params.page_size">
      </el-pagination>
    </div>
    <el-dialog title="添加、编辑版本" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
      <template>

        <!--################################禁用上传修改成填写链接地址###################################-->
        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
          <!--        <el-form-item label="下载地址">-->
          <!--           <el-upload-->
          <!--              action-->
          <!--              :show-file-list="false"-->
          <!--              :http-request="fnUploadRequest"-->
          <!--              accept="exe, apk"-->
          <!--              :before-upload="beforeAvatarUpload"-->
          <!--              :on-success="handleAvatarSuccess"-->
          <!--              drag-->
          <!--            >-->
          <!--            <i class="el-icon-upload">{{msg}}{{msg2}}</i>-->
          <!--            <div class="el-upload__text">-->
          <!--              将文件拖到此处，或-->
          <!--              <em>点击上传</em>-->
          <!--            </div>-->
          <!--            <div slot="tip" class="el-upload__tip">上传文件大小不能超过 1G；<span style="color: red;">注：<b>上传完成2</b>出现后填写以下信息</span></div>-->
          <!--          </el-upload>-->
          <!--        </el-form-item>-->
          <el-form-item class="content-left" label="下载地址" prop="downloads"
                        :rules="[{ required: true, message: '请输入下载地址', trigger: 'blur' }]">
            <el-input placeholder="请输入下载地址名称" v-model="form.downloads"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="版本名称" prop="version_name"
                        :rules="[{ required: true, message: '请输入版本名称', trigger: 'blur' }]">
            <el-input placeholder="请输入标签名称" v-model="form.version_name"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="版本号" prop="version_num"
                        :rules="[{ required: true, message: '请输入版本名称', trigger: 'blur' }]">
            <el-input placeholder="请输入标签名称" v-model="form.version_num"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="版本说明">
            <el-input type="textarea" :rows="3" placeholder="请输入版本说明" v-model="form.descvs"></el-input>
          </el-form-item>
          <!-- <el-form-item class="content-left" label="使用这个版本更新?">
            <el-radio-group v-model="form.is_save" size="small">
              <el-radio label="1" border>是</el-radio>
              <el-radio label="0" border>否</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="发布时间">

            <el-date-picker
                v-model="form.release_time"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm"
                default-time="00:00:00"
                :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>

          <el-form-item class="content-center">
            <el-button type="primary" @click="updateVsersionData">确定保存</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
  </div>
</template>
<script>

//首先第一行引入 ali-oss 插件并配置：
const OSS = require('ali-oss')
const client = new OSS({
  accessKeyId: 'XUvPF0xtbXun2b9k',  // 查看你自己的阿里云KEY
  accessKeySecret: 'WwDlbUHTCxLwVGfN5C8LTcX2Lm3o1d', // 查看自己的阿里云KEYSECRET
  bucket: 'vpcimage', // 你的 OSS bucket 名称
  region: 'oss-cn-beijing' // bucket 所在地址，我的是 华北2 北京
})
import {mapGetters} from 'vuex'
import {Message} from 'element-ui'
import {formatDate} from '../../../date.js'
import {saveVsersion, getVsersion, updateVsersion} from '@/api/wechat'

export default {
  name: 'upload',
  data () {

    return {
      imageUrl: '',
      msg: '',
      msg2: '',
      Ossurl: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      isEdit: false,
      versionList: [],
      loading: false,
      is_save: [
        {name: '是', value: 1},
        {name: '否', value: 2}
      ],
      total_count: 0,
      params: {
        page: 1,
        pageSize: 20,
        cate_name: '',
        sort: ''
      },
      form: {
        id: '',
        version_name: '',
        version_num: '',
        is_save: '0',
        downloads: '',
        descvs: '',
        release_time: ''
      },
      memberTagDialog: false
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    beforeAvatarUpload (file) {
      const isJPG = file.name.split('').reverse().join('').substring(0, 3).split('').reverse().join('') === 'apk'
      const isLt2M = file.size / 1024 / 1024 < 200
      if (!isJPG) {
        this.$message.error('上传包只能是 Apk 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传包大小不能超过 200MB!')
      }
      return isJPG && isLt2M
    },
    async fnUploadRequest (options) {
      try {
        let file = options.file // 拿到 file
        let fileName = file.name.substr(0, file.name.lastIndexOf('.'))
        let date = new Date().getTime()

        // 上传文件,这里是上传到OSS的 uploads文件夹下
        client.put('0app/' + file.name, file).then(res => {
          if (res.res.statusCode === 200) {
            this.Ossurl = 'http://img1.yaoking.cn/0app/' + file.name
            this.msg = '上传完成'
          } else {
            options.onError('上传失败')
          }
        })
        client.put('0app/yaoking.apk', file).then(res => {
          if (res.res.statusCode === 200) {
            this.msg2 = '2'
          } else {
            options.onError('上传失败')
          }
        })
      } catch (e) {
        options.onError('上传失败')
      }
    },
    // 图片上传成功回调
    handleAvatarSuccess (res) {
      if (res) this.imageUrl = res.url
    },
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getDataList()
    },
    addTemplate () { // 添加商品
      this.memberTagDialog = true
      this.form = {id: '', description: ''}
    },
    editAction (index, row) { // 编辑商品弹框
      this.form = row
      // this.Ossurl = this.form.downloads
      // let date = new Date(row.release_time * 1000)
      // this.form.release_time = formatDate(date, 'yyyy-MM-dd hh:mm')
      this.memberTagDialog = true
      console.log(this.form)
    },
    preview (index, row) { // 预览弹框
      this.dialogVisible = true
      this.dataInfo = row
    },
    searchData () {
      this.params.page = 1
      this.getDataList()
    },
    // 表单取消
    onCancel (form) {
      this.$refs.form.resetFields()
    },
    getDataList () {
      this.loading = true
      getVsersion(this.params).then(response => {
        this.versionList = response.data.data.list
        this.total_count = response.data.data.total_count
        this.loading = false
      }).catch(error => {
        this.loading = false
        this.$message({
          type: 'error',
          message: '获取列表信息出错'
        })
      })
    },
    typesearch () {
      this.params.page = 1
      getVsersion({page: 1, pageSize: -1, type: this.params.type}).then(res => {
        if (res.data) {
          this.category = res.data.data.list
        }
      })
      this.getDataList()
    },
    deleteAction (index, row) {

      this.$confirm('此操作将删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        deleteCate(row.id).then(response => {

          this.versionList.splice(index, 1)
          this.$message({
            message: '删除成功',
            type: 'success',
            duration: 5 * 1000
          })
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    getTaskTime (strDate) {
      let date = new Date(strDate)
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let str = y + '-' + m + '-' + d
      return str
    },
    switchAuth (index, row) {
      console.log(row)
      let params = {
        'id': row.id,
        'is_save': row.is_save
      }
      updateVsersion(row.id, params).then(res => {
        if (res.data.data) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getDataList()
        }
      })
    },
    saveSort (index, row) {
      let params = {
        'cate_name': row.cate_name,
        'sort': row.sort
      }
      updateVsersion(row.id, params).then(res => {
        if (res.data.data) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2 * 1000
          })
          this.getDataList()
        }
      })
    },
    getTimeStr (date) {
      return this.getTaskTime(new Date(parseInt(date) * 1000))
    },
    handleCancelLabelsDialog () {
      this.memberTagDialog = false
    },
    updateVsersionData () {
      this.memberTagDialog = false
      // this.form.downloads = this.Ossurl
      if (this.form.id) {
        // console.log(this.form)
        updateVsersion(this.form.id, this.form).then(res => {
          if (res.data.data) {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
            this.getDataList()
          } else {
            this.memberTagDialog = true
          }
        })
      } else {
        saveVsersion(this.form).then(res => {
          if (res.data.data) {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
            this.getDataList()
          } else {
            this.memberTagDialog = true
          }
        })
      }
    }
  },
  mounted () {
    this.getDataList()
  }
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  img {
    width: 90%;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 10px;

  img {
    width: 90%;
  }
}

.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}

.service-label .el-checkbox:first-child {
  margin-left: 15px;
}

.service-label .el-input:first-child {
  margin-left: 15px;
}

.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}

.el-carousel {
  width: 375px;
}
</style>
<style lang="scss">
.grid-detail {
  table, .detail-content-wrap, .detail-content-item {
    width: 100% !important;
  }

  img {
    width: 100%;
  }
}

.grid-attribute {
  table {
    width: 100% !important;
  }
}

i.el-icon-plus.avatar-uploader-icon {
  font-size: 0.2em;
  width: 100%;
  /* height: 38px; */
}
</style>



// WEBPACK FOOTER //
// version.vue?db7b5ff8